import { render, staticRenderFns } from "./onlineDoc.vue?vue&type=template&id=a5df245e&scoped=true&"
import script from "./onlineDoc.vue?vue&type=script&lang=js&"
export * from "./onlineDoc.vue?vue&type=script&lang=js&"
import style0 from "./onlineDoc.vue?vue&type=style&index=0&id=a5df245e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5df245e",
  null
  
)

export default component.exports